export class ChildDropDownItem {
  constructor(
    public fieldId: number,
    public id: string) { }
}
